import { useState } from "react";
import axiosInstance from "../utils/axiosConfig";
import moment from "moment";

export const useSchedules = (currentUser) => {
  const [schedules, setSchedules] = useState([]);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [adminViewMode, setAdminViewMode] = useState("form");
  const [loadingLabel, setLoadingLabel] = useState("");
  const [isSyncingNew, setIsSyncingNew] = useState(false);

  const getMonthName = (month, year) =>
    moment(`${year}-${month}`, "YYYY-M").locale("en").format("MMMM");

  const fetchSchedules = async ({ month, year }) => {
    console.log(month);
    
    try {
      setLoadingLabel(`📅 Cargando agendas de ${month}/${year}...`);
      const response = await axiosInstance.get("/schedules/light", {
        params: {
          month: moment(`${year}-${month}`, "YYYY-M")
            .locale("en")
            .format("MMMM"),
          year,
        },
      });

      const formatted = response.data.map((schedule) => ({
        ...schedule,
        start: new Date(schedule.start_time),
        end: new Date(schedule.start_time), // no hay end_time en light
        title: `${schedule.description}`,
      }));

      setSchedules(formatted);
    } catch (err) {
      console.error("Error al cargar agendas", err);
      setLoadingLabel("❌ Error al cargar las agendas");
    } finally {
      setTimeout(() => setLoadingLabel(""), 1500);
    }
  };

  const refreshSchedulesIfNeeded = async ({ month, year }) => {
    try {
      setIsSyncingNew(true);
      setLoadingLabel("🔄 Cargando nuevos servicios creados...");

      const response = await axiosInstance.get("/schedules/light", {
        params: {
          month: getMonthName(month, year),
          year,
        },
      });

      const formatted = response.data.map((schedule) => ({
        ...schedule,
        start: new Date(schedule.start_time),
        end: new Date(schedule.start_time),
        title: `${schedule.service_type} ${
          currentUser === "admin" ? `- ${schedule.status}` : ""
        }`,
      }));

      setSchedules(formatted);
    } catch (err) {
      console.error("Error sincronizando nuevos schedules", err);
    } finally {
      setIsSyncingNew(false);
      setLoadingLabel("");
    }
  };

  const handleEventSelect = async (event) => {
    try {
      setLoadingLabel("Cargando detalle...");
      const { data } = await axiosInstance.get(`/schedules/${event.id}`);
      setSelectedSchedule(data);
      setModalIsOpen(true);
    } catch (err) {
      console.error("Error al cargar schedule por id", err);
    } finally {
      setLoadingLabel(null);
    }
  };

  const handleCompleteService = async () => {
    const response = await axiosInstance.patch(
      `/schedules/${selectedSchedule.id}`,
      {
        schedule: {
          status: "completed",
        },
      }
    );

    const schedule = response.data;
    setSelectedSchedule(schedule);

    const date = new Date(schedule.start_time);
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    await refreshSchedulesIfNeeded({ month, year });
  };

  return {
    schedules,
    selectedSchedule,
    setSelectedSchedule,
    modalIsOpen,
    setModalIsOpen,
    adminViewMode,
    setAdminViewMode,
    fetchSchedules,
    refreshSchedulesIfNeeded,
    handleEventSelect,
    handleCompleteService,
    loadingLabel,
    isSyncingNew,
    setLoadingLabel,
  };
};
